import React, { useMemo } from 'react';

import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import { useMisDocumentos } from '@/hooks/employee/useMisDocumentos';
import { MyDocumentsList } from '@/components/features/employee/MyDocumentsList';
import { useTranslation } from '@/i18n';


export const MyDocuments: React.FC = () => {
  const { t: translate } = useTranslation();

  const {
    activeTab,
    setActiveTab,
    dateRange,
    setDateRange,
    selectedFolder,
    setSelectedFolder,
    selectedDocumentType,
    setSelectedDocumentType,
    onSearch,
    columns,
    actions,
    rows,
    total,
    loading,
    page,
    setPage,
    pageSize,
    setPageSize,
    onSortChange,
    folderOptions,
    documentTypeOptions,
  } = useMisDocumentos();

  const tabs = useMemo(
    () => [
      {
        id: 'documentos',
        label: translate('employee:misDocumentos.tabs.documentos'),
        content: (
          <MyDocumentsList
            filters={{
              dateRange,
              setDateRange,
              selectedFolder,
              setSelectedFolder,
              selectedDocumentType,
              setSelectedDocumentType,
              folderOptions,
              documentTypeOptions,
            }}
            table={{
              columns,
              actions,
              rows,
              total,
              loading,
              page,
              setPage,
              pageSize,
              setPageSize,
              onSortChange,
              onSearch,
            }}
          />
        ),
      },
      {
        id: 'firmas',
        label: translate('employee:misDocumentos.tabs.firmas'),
        // TODO: ASIS-4413 follow-up — implementar vista de firmas
        content: <div data-testid="mis-documentos-firmas-tab" />,
      },
    ],
    [
      translate,
      dateRange,
      setDateRange,
      selectedFolder,
      setSelectedFolder,
      selectedDocumentType,
      setSelectedDocumentType,
      folderOptions,
      documentTypeOptions,
      onSearch,
      columns,
      actions,
      rows,
      total,
      loading,
      page,
      setPage,
      pageSize,
      setPageSize,
      onSortChange,
    ],
  );

  return (
    <PageLayout dynamicTitle={translate('employee:misDocumentos.pageTitle')}>
      <div data-testid="mis-documentos-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={(id) => setActiveTab(id as 'documentos' | 'firmas')}
        />
      </div>
    </PageLayout>
  );
};

export default MyDocuments;
